import React from 'react'
import "../styles/finance.css" 
import "../styles/financeCalculator.css" 
import FinanceCalculator from '../components/FinanceCalculator';
import b from "../images/banks/c.png"
import kcb from "../images/banks/kcb.png"
import ncba from "../images/banks/ncba.png"
import absa from "../images/banks/absa.png"
import equity from "../images/banks/equity.png"
import kb from "../images/banks/kb.png"

const Financing = () => {

const steps = [
  {
    title: "Choose Your Vehicle",
    description:
      "Browse our inventory and select a vehicle that matches your budget and preferences."
  },
  {
    title: "Submit Application",
    description:
      "Provide the required documents for loan assessment."
  },
  {
    title: "Approval Process",
    description:
      "Our financing partners review and approve your application."
  },
  {
    title: "Vehicle Delivery",
    description:
      "Drive away once financing is finalized."
  }
];

  return (
   <>
    <section className="finance-hero">
    <div className="finance-hero-content">
        <span>Vehicle Financing</span>

        <h1>
        Drive Your Dream Car Today,
        Pay Comfortably Over Time
        </h1>

        <p>
        Through our trusted financing partners,
        we help you secure flexible vehicle loans
        with competitive rates and convenient
        repayment terms.
        </p>

        <a href="#calculator" className="primary-btn">
        Calculate Your Monthly Payment
        </a>
    </div>
    </section>
    <section className="finance-benefits">
    <div className="top-header">
        <span>Why Finance With Us</span>
        <h2>Simple, Fast & Flexible Financing</h2>
    </div>

    <div className="benefits-grid">

        <div className="benefit-card">
        <h3>Fast Approvals</h3>
        <p>
            Get financing decisions quickly
            through our banking partners.
        </p>
        </div>

        <div className="benefit-card">
        <h3>Flexible Repayment Terms</h3>
        <p>
            Choose repayment periods that fit
            your financial goals.
        </p>
        </div>

        <div className="benefit-card">
        <h3>Competitive Interest Rates</h3>
        <p>
            Access affordable financing options
            from trusted lenders.
        </p>
        </div>

        <div className="benefit-card">
        <h3>Expert Guidance</h3>
        <p>
            We assist throughout the application
            and approval process.
        </p>
        </div>

    </div>
    </section>
    <section id="calculator">
    <FinanceCalculator />
    </section>
    <section className="finance-partners">

    <div className="top-header">
        <span>Trusted Partners</span>
        <h2>Financing Backed By Leading Banks</h2>
    </div>

    <p className="partners-text">
        We collaborate with reputable financial
        institutions across Kenya to provide
        reliable vehicle financing solutions.
    </p>

    <div className="partners-grid">

        <div className="partner-card">
        <img src={ncba} alt="NCBA" />
        </div>

        <div className="partner-card">
        <img src={kcb} alt="KCB" />
        </div>

        <div className="partner-card">
        <img src={b} alt="Co-operative Bank" />
        </div>

        <div className="partner-card">
        <img src={absa} alt="Absa" />
        </div>

        <div className="partner-card">
        <img src={kb} alt="kb" />
        </div>

        <div className="partner-card">
        <img src={equity} alt="Equity" />
        </div>

    </div>

    </section>

 

  
   </>
  )
}

export default Financing